<template>
  <main class="page-sidebar page-padding error-page">
    <h1>403</h1>
  </main>
</template>

<script>
  export default {
    name: 'errorPage403',

  }
</script>

<style scoped>
  main {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  h1 {
    font-size: 200px;
    text-align: center;
  }
</style>
